export interface PropertyDTO {
  code?: string;
  usages?: any[];
  dataTypeCode?: DataTypeCode;
  description?: string;
  detailedDescription?: any[];
  additionalData?: any[];
  mandatory?: boolean;
  enabled?: boolean;
  createdOn?: string;
  updatedOn?: string;
  value?: string;
}

export enum DataTypeCode {
  TEXT = "TEXT",
  NUMERIC = "NUMERIC",
  DATE = "DATE",
  BOOLEAN = "BOOLEAN",
}

export interface PropertyUsages {
  code?: string;
  description?: string;
  enabled?: boolean;
}

export interface PropertyDataType {
  code?: string;
  description?: string;
}
